import { ResolverTag } from '@ps/web-core-enums';
import { Translation, useResolver } from '@ps/web-shared-components';
import { StarsInfo, StarsLink } from '@ps/web-shared-ui';
import React from 'react';

import { styles as sharedStyles } from '@swf/account';

import {
  TXTCLI_Click_here_to_learn_more_about_ELL_1,
  TXTCLI_For_your_protectionX_we_offer__ELL
} from './AccountSecurityInfo.messages.json';

const AccountSecurityInfo: React.FC = () => {
  const gameSecurity = useResolver(ResolverTag.GameSecurity);

  return (
    <div className={sharedStyles.message}>
      <StarsInfo>
        <Translation {...TXTCLI_For_your_protectionX_we_offer__ELL} />
        <div>
          <StarsLink href={gameSecurity} target="_blank" rel="noopener noreferrer">
            <Translation {...TXTCLI_Click_here_to_learn_more_about_ELL_1} />
          </StarsLink>
        </div>
      </StarsInfo>
    </div>
  );
};

export default AccountSecurityInfo;
